import * as api from "Api";
import * as actions from "Actions";

export const fetchSlides = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;

    const { lng } = getState().params;

    dispatch(
      actions.fetchSlides(
        api
          .getSlides({ uen: currentOrganization.uen, language: lng })
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const fetchDashboardMetadata = dashboardId => {
  return (dispatch, getState) => {
    const {
      auth: { currentOrganization },
      params: { backOffice }
    } = getState();

    return dispatch(
      actions.fetchDashboardMetadata(
        api.getDashboardMetadata({
          id: dashboardId,
          uen: currentOrganization.uen,
          status: backOffice ? "STANDARD" : "CREATED"
        })
      )
    );
  };
};

export const saveDashboardComposition = dashboardId => (dispatch, getState) => {
  const {
    dashboardComposition: {
      composition: { labels, slidesOrder, isPublic, isEditable }
    },
    auth: { currentOrganization },
    params: { backOffice }
  } = getState();

  return dispatch(
    actions.saveDashboardComposition(
      api.saveDashboardComposition({
        uen: currentOrganization.uen,
        dashboardId,
        labels,
        slidesOrder,
        status: backOffice ? "STANDARD" : "CREATED",
        isPublic: backOffice ? true : isPublic,
        isEditable
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/dashboardComposition.js